import moment from "moment";

export default (date? : string, withoutSuffix? : boolean) : string => {
	if (!date) {
		return "";
	}

	return moment(date).fromNow(withoutSuffix);
}
